export const togglebuttonStyle = () => {
  return {
    width: 'inherit',
  };
};
